import { mount } from "@/lib/mount";
import { Landing } from "@/pages/Landing";

mount(<Landing />);
